import React from 'react';
import TextWithBoldPrefix from "./TextWithBoldPrefix";

interface NumberedComponentProps {
	index?: string;
	title?: string;
	description?: string;
	list?: (string | React.ReactNode)[];
	secondDescription?: string;
	boldPrefix?: boolean
	className?: string
	isGrayList?: boolean
	isList?: boolean
}

const NumberedComponent = (props: NumberedComponentProps) => {
	// _${props.index}
	return (
		<div className={`numberedListComponent`}>
			{
				props.title && (
					<div className='numberedListComponent__title'>
						<h2>{props.index}.</h2>
						<h2>{props.title}</h2>
					</div>
				)
			}
			{
				props.description && (
					<div className="numberedListComponent__description">
						<span>
							{props.description}
						</span>
					</div>
				)
			}
			{
				props.list && props.list.length > 0 && (
					<ul className="numberedListComponent__content" style={{ listStyle: props.isList ? 'none' : 'disc', padding: props.isList ? '0 0 0 0' : '0 0 0 26px' }}>
						{props.list?.map((item, idx) => (
							<li key={idx} style={{ color: props.isGrayList ? '#ABAAB7' : '#FFFFFF' }}>
								{typeof item === 'string'
									? <TextWithBoldPrefix text={item} boldPrefix={props.boldPrefix} />
									: item
								}
							</li>
						))}
					</ul>

				)
			}
			{
				props.secondDescription && (
					<div className="numberedListComponent__description">
						<span>
							{props.secondDescription}
						</span>
					</div>
				)
			}
		</div>
	);
};

export default NumberedComponent;